import React from "react";

/**
 * Reusable Step Card Component (for How It Works)
 * @param {string} number - Step number (01, 02, etc)
 * @param {React.Component} icon - Icon component from lucide-react
 * @param {string} title - Step title
 * @param {string} description - Step description
 */
const StepCard = ({ number, icon: IconComponent, title, description }) => (
  <div className="how-card">
    <h1 className="step-number fw-bold">{number}</h1>
    <div className="ms-3 step-content">
      <div className="d-flex align-items-center gap-2 mb-2 mt-3">
        <IconComponent size={20} className="primary-class" />
        <h6 className="mb-0 fw-bold primary-class">{title}</h6>
      </div>
      <p>{description}</p>
    </div>
  </div>
);

export default StepCard;
